import { Course } from "@/models/courses.model";
import { QueryParams } from "@/models/query-params.model";
import { Status, User } from "@/models/user.model";
import { CoursesRest } from "@/services/rest/courses.rest";
import { UsersRest } from "@/services/rest/users.rest";
import { getUserFromStorage } from "@/utils/user-store.util";
import { BehaviorSubject, Observable, map, take } from "rxjs";

export class StatsService {
  constructor(
    private _courses = new CoursesRest(),
    private _users = new UsersRest()
  ) {}

  private courses$: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  courses: Observable<Course> = this.courses$.asObservable();

  private users$: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  users: Observable<User> = this.users$.asObservable();

  private static classroomId$ = new BehaviorSubject<string | undefined>(
    undefined
  );
  static classroom = this.classroomId$.asObservable();

  private static hasClassroom$ = new BehaviorSubject<boolean | undefined>(
    false
  );
  static hasClassroom = this.hasClassroom$.asObservable();

  getCourses(queryParams: QueryParams): void {
    this._courses
      .getCourses(queryParams)
      .pipe(take(1))
      .subscribe((response) => {
        this.courses$.next(response);
      });
  }
  getStudents(queryParams: QueryParams): void {
    this._users
      .getUsers(queryParams)
      .pipe(
        take(1),
        map((e: any) => {
          e.content.forEach((item: any) => {
            item.status = "CONCLUDED";
            item.status = this.remakeObjectStatus(item.status);
            item.courseId = "8713797a-c21f-4c5e-8b4a-86d2e0c2b6e6";
          });
          return e;
        })
      )
      .subscribe((response) => {
        this.users$.next(response);
      });
  }
  remakeObjectStatus(item: any): any {
    var status = { name: "", class: "", value: "" };
    status.name = this.getStatus(item);
    status.class = this.getStatusColor(item);
    status.value = item;
    return status;
  }
  getStatus(status: string): string {
    if (status == Status.PROGRESS) {
      status = "Em progresso";
    } else if (status == Status.INACTIVATED) {
      status = "Inativo";
    } else if (status == Status.CONCLUDED) {
      status = "Concluído";
    }
    return status;
  }
  getStatusColor(status: string): string {
    if (status == Status.PROGRESS) {
      status = "bg-h-info-100 text-h-info-800";
    } else if (status == Status.INACTIVATED) {
      status = "bg-h-error-100 text-h-error-800";
    } else if (status == Status.CONCLUDED) {
      status = "bg-h-success-100 text-h-success-500";
    }
    return status;
  }

  static setClassroomId(value: string): void {
    StatsService.classroomId$.next(value);
  }

  static setHasClassroom(value: boolean): void {
    StatsService.hasClassroom$.next(value);
  }
}
